// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__IoQT5","head":"ProcedureTableInfo_head__1hBg9"};